import API from './api';
import { exportResults } from '../utils/index';
import { HTTP } from '../config/http-common';

export default class FolderItems extends API { }
